import { render, staticRenderFns } from "./AccountVerificationPanel.vue?vue&type=template&id=780cc29d&scoped=true&"
import script from "./AccountVerificationPanel.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationPanel.vue?vue&type=script&lang=js&"
import style0 from "./AccountVerificationPanel.vue?vue&type=style&index=0&id=780cc29d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780cc29d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780cc29d')) {
      api.createRecord('780cc29d', component.options)
    } else {
      api.reload('780cc29d', component.options)
    }
    module.hot.accept("./AccountVerificationPanel.vue?vue&type=template&id=780cc29d&scoped=true&", function () {
      api.rerender('780cc29d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/shared/AccountVerificationPanel.vue"
export default component.exports